export const COMPANY = {
  name: "RB Glasfiber A/S",
  cvr: "36979518",
  phone: "30 13 61 16",
  phoneRaw: "+4530136116",
  email: "torben@rb-glasfiber.dk",
  contactPerson: "Torben Peter Nielsen",
  address: {
    street: "Jernvej 6, Mønsted",
    postalCode: "8800",
    city: "Viborg",
    full: "Jernvej 6, Mønsted, 8800 Viborg",
  },
  logo: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-logo.png",
  icon: "https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-ikon.png",
};

export const FALLBACK_MENU = [
  {
    title: "RB Glasfiber",
    href: "/rb-glasfiber",
    children: [
      { title: "Pumpebrønde & tanke", href: "/rb-glasfiber/pumpebronde-amp-tanke" },
      { title: "Reparationer", href: "/rb-glasfiber/reparationer" },
      { title: "Overdækning", href: "/rb-glasfiber/overdaekning" },
      { title: "Specialopgaver", href: "/rb-glasfiber/specialopgaver" },
    ],
  },
  {
    title: "Standard produkter",
    href: "/produkter",
    children: [
      { title: "Glasfiber containere", href: "/produkter/glasfiber-containere" },
      { title: "Iglo & fancy", href: "/produkter/iglo-amp-fancy" },
      { title: "Fancy", href: "/produkter/iglo-amp-fancy#anchor185" },
      { title: "Joca igloer", href: "/produkter/iglo-amp-fancy#anchor186" },
      { title: "Klæbemærker", href: "/produkter/iglo-amp-fancy#anchor187" },
      { title: "Batteribokse", href: "/produkter/batteribokse" },
      { title: "Sand-salt containere", href: "/produkter/sand-salt-containere" },
      { title: "Salgs- & Leveringsbetingelser (PDF)", href: "/handelsbetingelser" },
    ],
  },
  {
    title: "Information",
    href: "/information",
    children: [
      { title: "CE Godkendelser", href: "/information/ce-godkendelser" },
      { title: "Samarbejdspartnere", href: "/information/samarbejdspartnere" },
    ],
  },
  {
    title: "Referencer",
    href: "/referencer",
    children: [],
  },
  {
    title: "Kontakt",
    href: "/kontakt",
    children: [],
  },
];
